// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oc-home-wrapper {
  background-color: var(--oc-primary-bg);
  overflow-x: hidden;
}

.oc-card .card-title {
  font-family: DMSans-Bold;
  font-size: 1.625em;
  line-height: 1.5em;
  color: var(--oc-primary-bg);
}
.oc-card .card-text {
  font-family: DMSansMedium;
  font-size: 1.125em;
  line-height: 1.375em;
  color: var(--oc-secondary-text);
}
.oc-card .card-link {
  font-size: 1.125em;
  line-height: 1.375em;
  color: #000;
}
`, "",{"version":3,"sources":["webpack://./src/pages/private/home/Home.css"],"names":[],"mappings":"AAAA;EACE,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;AACb","sourcesContent":[".oc-home-wrapper {\n  background-color: var(--oc-primary-bg);\n  overflow-x: hidden;\n}\n\n.oc-card .card-title {\n  font-family: DMSans-Bold;\n  font-size: 1.625em;\n  line-height: 1.5em;\n  color: var(--oc-primary-bg);\n}\n.oc-card .card-text {\n  font-family: DMSansMedium;\n  font-size: 1.125em;\n  line-height: 1.375em;\n  color: var(--oc-secondary-text);\n}\n.oc-card .card-link {\n  font-size: 1.125em;\n  line-height: 1.375em;\n  color: #000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
